export let Evaluation = {
  name: '',
  nameJa: '',
  value: 0,
  score: 0,
  description: {
    text: ''
  }
}

export const EVALUATION_TITLE_TIP = `[Too Good]
                                      非常に良いモデルです。
                                      ただし、データ件数が少なかったり、データ項目に飛びぬけて影響度の強い項目がある場合は、要注意です。
            
                                      [Good]
                                      良いモデルです。
                                      その他の性能評価もチェックしておきましょう。
            
                                      [Middle]
                                      まぁまぁです。
                                      項目の影響度や、学習データのサマリを見ながら、もっと上げられるよう工夫してみると良いでしょう。
            
                                      [Weak]
                                      ちょっと弱いモデルです。
                                      影響度が0のデータ項目や、予測対象との関係性が見られないデータ項目が多い場合は、他のデータ項目がないか検討が必要です。
            
                                      [Bad]
                                      非常に弱いモデルです。
                                      全般的に、データ項目を見直す必要があるかもしれません。`



// WEBPACK FOOTER //
// ./src/defines/model/evaluation.js